"use strict";
exports.__esModule = true;
exports.ILLEGAL_TRITS_LENGTH = 'Illegal trits length';
exports.ILLEGAL_WORDS_LENGTH = 'Illegal words length';
//# sourceMappingURL=errors.js.map